import React, { useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import PainPointsSection from '../components/sections/PainPointsSection';
import BeliefSection from '../components/sections/BeliefSection';
import ServicesSection from '../components/sections/ServicesSection';
import StrengthFrameworkSection from '../components/sections/StrengthFrameworkSection';
import RetrainSection from '../components/sections/RetrainSection';
import JourneySection from '../components/sections/JourneySection';
import IdealCompanySection from '../components/sections/IdealCompanySection';
import SAPComparisonSection from '../components/sections/SAPComparisonSection';
import ComparisonSection from '../components/sections/ComparisonSection';
import ROICalculatorSection from '../components/sections/ROICalculatorSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import StatsSection from '../components/sections/StatsSection';
import FAQSection from '../components/sections/FAQSection';
import IndustriesSection from '../components/sections/IndustriesSection';
import CalendarModal from '../components/modals/CalendarModal';
import LiveChatWidget from '../components/widgets/LiveChatWidget';
import WhatsAppButton from '../components/widgets/WhatsAppButton';

const HomePage = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const openCalendar = () => setIsCalendarOpen(true);
  const closeCalendar = () => setIsCalendarOpen(false);

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-page)' }}>
      <Header onOpenCalendar={openCalendar} />
      
      <main>
        <HeroSection onOpenCalendar={openCalendar} />
        <StatsSection />
        <PainPointsSection />
        <BeliefSection />
        <IdealCompanySection onOpenCalendar={openCalendar} />
        <ServicesSection />
        <StrengthFrameworkSection />
        <RetrainSection onOpenCalendar={openCalendar} />
        <JourneySection />
        <SAPComparisonSection onOpenCalendar={openCalendar} />
        <ComparisonSection onOpenCalendar={openCalendar} />
        <ROICalculatorSection onOpenCalendar={openCalendar} />
        <TestimonialsSection />
        <IndustriesSection />
        <FAQSection />
      </main>

      <Footer onOpenCalendar={openCalendar} />
      
      {/* Calendar Modal */}
      <CalendarModal isOpen={isCalendarOpen} onClose={closeCalendar} />
      
      {/* WhatsApp Button */}
      <WhatsAppButton />
      
      {/* Live Chat Widget - Zen1 */}
      <LiveChatWidget onOpenCalendar={openCalendar} />
    </div>
  );
};

export default HomePage;
